import type { PropsWithChildren } from 'react';
import clsx from 'clsx';
import PageError from './PageError';
import LoadingSpinner from '@/components/ui/LoadingSpinner';

interface PageWrapperProps extends PropsWithChildren {
  isLoading?: boolean;
  isError?: boolean;
  errorText?: string;
  errorTitleText?: string;
  className?: string;
}

const PageWrapper = ({
  children,
  isLoading,
  isError,
  errorText,
  errorTitleText,
  className,
}: PageWrapperProps) => {
  if (isLoading) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  if (isError) {
    return <PageError errorText={errorText} titleText={errorTitleText} />;
  }

  return (
    <div className={clsx('mx-auto flex h-full w-full flex-col', className)}>
      {children}
    </div>
  );
};

export default PageWrapper;
